module.exports = __webpack_public_path__ + "media/images/unknown-profile-4ad0d11cd1b6356bfe2ba1f8212c0504.jpg";